export default
  [
    {
      path: '',
      redirect: 'platformDriverManage'
    },
    // ------------------认证用户管理
    // 
    {
      path: 'platformDriverManage',
      name: '/landCenter/platformDriverManage',
      component: () => import('@/page/landCenter/authUserManagement/platformDriverManage'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'platformDriverManage' }
    },
    {
      path: 'platformDriverManage/:id',
      name: 'landCenter/platformDriverManage/detail',
      component: () => import('@/page/landCenter/authUserManagement/platformDriverManageDetail'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'platformDriverManage' },
      props: true
    },
    {
      path: 'truckFleetManage',
      name: '/landCenter/truckFleetManage',
      component: () => import('@/page/landCenter/authUserManagement/truckFleetManage'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'truckFleetManage' }
    },
    {
      path: 'truckFleetManage/:id',
      name: 'landCenter/truckFleetManage/detail',
      component: () => import('@/page/landCenter/authUserManagement/truckFleetManageDetail'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'truckFleetManage' },
      props: true
    },
    {
      path: 'fleetDriverManage',
      name: '/landCenter/fleetDriverManage',
      component: () => import('@/page/landCenter/authUserManagement/fleetDriverManage'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'fleetDriverManage' }
    },
    {
      path: 'fleetDriverCreate', // 创建车队司机
      name: '/landCenter/fleetDriverCreate',
      component: () => import('@/page/landCenter/authUserManagement/fleetDriverOperation'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'fleetDriverManage' }
    },
    {
      path: 'fleetDriverOperation/:id', // 编辑车队司机
      name: '/landCenter/fleetDriverOperation',
      component: () => import('@/page/landCenter/authUserManagement/fleetDriverOperation'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'fleetDriverManage' },
      props: true
    },
    {
      path: 'fleetDriverManage/:id',
      name: 'landCenter/fleetDriverManage/detail',
      component: () => import('@/page/landCenter/authUserManagement/fleetDriverManageDetail'),
      meta: { openKeyName: '认证用户管理', selectKeyUrl: 'fleetDriverManage' },
      props: true
    },

    // ------------------运单管理
    // sourceDocumentAudit
    {
      path: 'sourceDocumentAudit',
      name: '/landCenter/sourceDocumentAudit',
      component: () => import('@/page/landCenter/waybillManagement/sourceDocumentAudit'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'sourceDocumentAudit' }
    },
    {
      path: 'sourceDocumentAudit/:id',
      name: '/landCenter/sourceDocumentAuditDetail',
      component: () => import('@/page/landCenter/waybillManagement/sourceDocumentAuditDetail'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'sourceDocumentAudit' },
      props: true
    },
    // sourceDocumentManage
    {
      path: 'sourceDocumentManage',
      name: '/landCenter/sourceDocumentManage',
      component: () => import('@/page/landCenter/waybillManagement/sourceDocumentManage'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'sourceDocumentManage' }
    },
    {
      path: 'sourceDocumentManage/:id',
      name: '/landCenter/sourceDocumentManageDetail',
      component: () => import('@/page/landCenter/waybillManagement/sourceDocumentManageDetail'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'sourceDocumentManage' },
      props: true
    },
    // waybillManage
    {
      path: 'waybillManage',
      name: '/landCenter/waybillManage',
      component: () => import('@/page/landCenter/waybillManagement/waybillManage'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'waybillManage' }
    },
    {
      path: 'waybillManage/:id',
      props: true,
      name: '/landCenter/waybillManage/detail',
      component: () => import('@/page/landCenter/waybillManagement/waybillManageDetail'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'waybillManage' }
    },
    // vehicleSourceInformation
    {
      path: 'vehicleSourceInformation',
      name: '/landCenter/vehicleSourceInformation',
      component: () => import('@/page/landCenter/waybillManagement/vehicleSourceInformation'),
      meta: { openKeyName: '运单管理', selectKeyUrl: 'vehicleSourceInformation' }
    },

    // ------------------车辆管理
    //platformCarManage
    {
      path: 'platformCarManage',
      name: '/landCenter/platformCarManage',
      component: () => import('@/page/landCenter/carManagement/platformCarManage'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'platformCarManage' }
    },
    {
      path: 'platformCarManage/:id',
      name: '/landCenter/platformCarManage/detail',
      component: () => import('@/page/landCenter/carManagement/platformCarManageDetail'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'platformCarManage' },
      props: true
    },
    //fleetCarManage
    {
      path: 'fleetCarManage',
      name: '/landCenter/fleetCarManage',
      component: () => import('@/page/landCenter/carManagement/fleetCarManage'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'fleetCarManage' }
    },
    {
      path: 'fleetCarManage/:id',
      name: '/landCenter/fleetCarManage/detail',
      component: () => import('@/page/landCenter/carManagement/fleetCarManageDetail'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'fleetCarManage' },
      props: true
    },
    {
      path: 'fleetCarManageCreate',
      name: '/landCenter/fleetCarManage/fleetCarManageCreate',
      component: () => import('@/page/landCenter/carManagement/fleetCarManageOpt'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'fleetCarManage' },
    },
    {
      path: 'fleetCarManageOpt/:id',
      name: '/landCenter/fleetCarManage/fleetCarManageOpt',
      component: () => import('@/page/landCenter/carManagement/fleetCarManageOpt'),
      meta: { openKeyName: '车辆管理', selectKeyUrl: 'fleetCarManage' },
      props: true
    },


    // ------------------网络货运上报
    {
      path: 'electronicWaybillReporting',
      name: '/landCenter/electronicWaybillReporting',
      component: () => import('@/page/landCenter/transportReport/electronicWaybillReporting'),
      meta: { openKeyName: '网络货运上报', selectKeyUrl: 'electronicWaybillReporting' }
    },
    {
      path: 'fundFlowReport',
      name: '/landCenter/fundFlowReport',
      component: () => import('@/page/landCenter/transportReport/fundFlowReport'),
      meta: { openKeyName: '网络货运上报', selectKeyUrl: 'fundFlowReport' }
    },

    // ------------------数据字典
    {
      path: 'modelManage',
      name: '/landCenter/modelManage',
      component: () => import('@/page/landCenter/dictManagement/modelManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'modelManage' }
    },
    {
      path: 'vehicleCommanderManage',
      name: '/landCenter/vehicleCommanderManage',
      component: () => import('@/page/landCenter/dictManagement/vehicleCommanderManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'vehicleCommanderManage' }
    },
    {
      path: 'vehicleWidthManage',
      name: '/landCenter/vehicleWidthManage',
      component: () => import('@/page/landCenter/dictManagement/vehicleWidthManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'vehicleWidthManage' }
    },
    {
      path: 'vehicleHeightManage',
      name: '/landCenter/vehicleHeightManage',
      component: () => import('@/page/landCenter/dictManagement/vehicleHeightManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'vehicleHeightManage' }
    },
    {
      path: 'goodsNameManage',
      name: '/landCenter/goodsNameManage',
      component: () => import('@/page/landCenter/dictManagement/goodsNameManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'goodsNameManage' }
    },
    {
      path: 'licensePlateColorManage',
      name: '/landCenter/licensePlateColorManage',
      component: () => import('@/page/landCenter/dictManagement/licensePlateColorManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'licensePlateColorManage' }
    },
    {
      path: 'typeManagementOfDriverLicense',
      name: '/landCenter/typeManagementOfDriverLicense',
      component: () => import('@/page/landCenter/dictManagement/typeManagementOfDriverLicense'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'typeManagementOfDriverLicense' }
    },
    {
      path: 'transportationRequirementsManage',
      name: '/landCenter/transportationRequirementsManage',
      component: () => import('@/page/landCenter/dictManagement/transportationRequirementsManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'transportationRequirementsManage' }
    },
    {
      path: 'bankTypeManage',
      name: '/landCenter/bankTypeManage',
      component: () => import('@/page/landCenter/dictManagement/bankTypeManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'bankTypeManage' }
    },
    {
      path: 'InsuranceCompanyManage',
      name: '/landCenter/InsuranceCompanyManage',
      component: () => import('@/page/landCenter/dictManagement/InsuranceCompanyManage'),
      meta: { openKeyName: '数据字典', selectKeyUrl: 'InsuranceCompanyManage' }
    },

  ]


// WEBPACK FOOTER //
// ./src/router/landCenter/index.js